import { type Html, html, View } from 'rune-ts';
import klass from './IndexSection.module.scss';
import { font, staticFont } from '@services/MarppleShop/shared/typography';

export class IndexSection extends View<{ is_mobile: boolean }> {
  override template(): Html {
    return html`
      <section class="${klass.container}">
        <div class="${klass.title_wrapper}">
          <div class="${staticFont('bebas_20_bold')} ${klass.chapter}">CHAPTER 1.</div>
          <div class="${font('48_bold', '28_bold')} ${klass.title}">
            오직 굿즈 파트너스에게만<br />제공되는 상품 제작비 할인 혜택
          </div>
        </div>
        <div class="${klass.content_wrapper}">
          <div class="${klass.top} ${font('28_bold', '20_bold')}">마플샵 굿즈 파트너스가 되면</div>
          <div class="${klass.middle}">
            <div class="${klass.discount} ${font('36_bold', '20_bold')}">상품 제작비 최대 20% 할인</div>
            <div class="${klass.discount_info} ${font('16_medium', '14_medium')}">
              * 마플샵제작배송 상품에 한함
            </div>
          </div>
          <div class="${klass.bottom}">
            <img
              src="//s3.marpple.co/files/u_29089/2025/11/original/1c7f6fbaa11a2f4567c5b6b65c03add739e6dda61.webp"
              alt=""
            />
          </div>
        </div>
      </section>
    `;
  }
}
